export enum UserTypeEnum {
  Company_Assets = "CA",
  All_Assets = "AT"
}
